import * as Sentry from "@sentry/react";
import Login from "./Components/Login";
import { Dashboard } from "./Components/Dashboard";
const code = new URLSearchParams(window.location.search).get("code");

function App() {
  return code ? <Dashboard code={code} /> : <Login />;
}
export default Sentry.withProfiler(App);
